import { cn } from "@/lib/utils";

/** Shared className for the form-row inputs (text/number/date inputs +
 *  inline selects). Centralised so every control row stays visually
 *  consistent. */
export const inputCls = cn(
  "w-full rounded-wx-sm border border-wx-border bg-wx-bg px-3 py-2 text-sm text-wx-fg",
  "focus:border-wx-primary focus:outline-none focus:ring-2 focus:ring-wx-primary/20",
  "read-only:cursor-not-allowed read-only:bg-wx-bg-elevated/60 read-only:text-wx-fg-muted",
  "disabled:cursor-not-allowed disabled:bg-wx-bg-elevated/60 disabled:text-wx-fg-muted",
);
